import React, { useMemo } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

// global scss for globally styles and fonts
import "./_fonts.scss";
import "./_global.scss";

import { WEB_ROUTES } from "./constants.js";
import { baseRoute } from "./Helper";
import PublicRoute from "./Components/Routes/PublicRoute.js";

import Account from "./Pages/Account";
import ProtectedLayout from "./Components/Layouts/ProtectedLayout.js";
import Dashboard from "./Pages/Dashboard";
// import Tournaments from "./Pages/Tournaments";
// import Messages from "./Pages/Messages";
import Setting from "./Pages/Setting";
// import Profile from "./Pages/Profile";
// import PaymentMethod from "./Pages/PaymentMethod";
import ProtectedRoute from "./Components/Routes/ProtectedRoute.js";
import SendNotificationScreen from "./Pages/SendNotification/SendNotificationScreen.js";
import { uniqueId } from "lodash";
import PostManagementScreen from "./Pages/PostManagement/PostManagementScreen.js";
import PostReportManagementScreen from "./Pages/PostReportManagement/PostReportManagementScreen.js";
import GroupManagementScreen from "./Pages/GroupManagement/GroupManagementScreen.js";
import EventManagementScreen from "./Pages/eventManagement/EventManagementScreen.js";
import OfficerManagementScreen from "./Pages/OfficerManagement/OfficerManagementScreen.js";
import DispatcherManagementScreen from "./Pages/DispatcherManagement/DispatcherManagementScreen.js";
import FAQManagementScreen from "./Components/FAQManagement/FAQManagementScreen.js";
import UserFeedbackScreen from "./Pages/UserFeedback/UserFeedbackScreen.js";
// import TournamentManagementScreen from "./Pages/TournamentManagement/TournamentManagementScreen.js";
// import TournamentManagement from './Pages/TournamentManagement';
function App() {
  // todo: menu
  const ROUTES = useMemo(() => {
    return [
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.ACCOUNT)}
        element={
          <PublicRoute>
            <Account />
          </PublicRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.DASHBOARD)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false} selectedRoute={0}>
              <Dashboard />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.DISPACHTER_MANAGEMENT)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false} selectedRoute={1}>
              <DispatcherManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.OFFICER_MANAGEMENT)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false} selectedRoute={2}>
              <OfficerManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.FAQS)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false} selectedRoute={3}>
              <FAQManagementScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
      key={uniqueId}
      exact
      path={baseRoute(WEB_ROUTES.USER_FEEDBACK)}
      element={
        <ProtectedRoute>
          <ProtectedLayout isSearchBar={false} selectedRoute={4}>
            <UserFeedbackScreen />
          </ProtectedLayout>
        </ProtectedRoute>
      }
    />,
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.SEND_NOTIFICATION)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false} selectedRoute={5}>
              <SendNotificationScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId}
        exact
        path={baseRoute(WEB_ROUTES.SETTING)}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false} selectedRoute={6}>
              <Setting />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      // <Route key={uniqueId} exact path={baseRoute(WEB_ROUTES.PROFILE)} element={
      //   <ProtectedRoute>
      //     <ProtectedLayout isSearchBar={false} selectedRoute={2}>
      //       <Profile />
      //     </ProtectedLayout>
      //   </ProtectedRoute>
      // } />,
    ];
  }, []);

  return (
    <Router>
      <Routes>
        {ROUTES.map((item) => item)}
        <Route
          path={baseRoute("*")}
          element={<Navigate to={baseRoute(WEB_ROUTES.ACCOUNT)} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
